
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'
// 分组列表
export function getGroupList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group',
    method: 'GET',
    params: parameter
  })
}
// 新增分组
export function addGroup (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group',
    method: 'POST',
    data: parameter
  })
}
// 编辑分组
export function editGroup (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group',
    method: 'PUT',
    data: parameter
  })
}
// 删除分组
export function deleteGroup (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/group/${parameter}`,
    method: 'DELETE'
  })
}
// 分组用户列表
export function getUserList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group/user',
    method: 'GET',
    params: parameter
  })
}
// 删除分组用户
export function deleteGroupUser (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group/user',
    method: 'DELETE',
    params: parameter
  })
}
// 获取分组可添加人员列表
export function getUserChooseList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group/user/choose',
    method: 'GET',
    params: parameter
  })
}
// 人员添加分组
export function insertGroup (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/group/user',
    method: 'POST',
    data: parameter
  })
}
// 获取select数据
export function getGroup (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
